<template>
  <div class="row">
    <div class="col-md-9">
      <h3><a :href="kurzLink">{{ item.name }}</a>
      </h3>

      <a class="category__school" :href="schoolLink">{{ item.schools.name }}</a> <span
        class="category__location"><span class="gray-400">|</span> {{ item.cities.name }}
                    - {{ item.states.name }}</span>

    </div>
    <div class="col-md-3">
      <div class="category__price-box">


        <span v-if="item.lowprice_2week || item.lowprice_1week" class="category__price-text">Cena od</span>
        <span v-else class="category__price-text">Cena</span>

        <span v-if="item.lowprice_1week" class="category__price">
          {{ Number(item.lowprice_1week.toFixed(0)).toLocaleString() }} Kč / <span class="small">týden</span>
          </span>
        <span v-else-if="item.lowprice_2week" class="category__price">
          {{ Number(item.lowprice_2week.toFixed(0)).toLocaleString() }} Kč / <span class="small">2 týdny</span>
          </span>
        <span v-else class="category__price">
          Uvedena v detailu
          </span>

      </div>

    </div>
  </div>

</template>
<script>
export default {
  props: ['item'],
  computed: {
    schoolLink() {
      return `/schools/detail/${this.item.objectID}`;
    },
    kurzLink(){
      return `/courses/detail/${this.item.objectID}`;
    }
  }
}
</script>
<style>
.ais-RefinementList-count{
  background-color: white;
}
.ais-RefinementList-count:before{
  content: "(";
}
.ais-RefinementList-count:after{
  content: ")";
}
</style>